import React from 'react';

const EditorContext = React.createContext({
	activeSlot: null,
	pageListOpen: false,
	controlsOpen: false,
	togglePageListHandler: () => {},
	toggleControlsHandler: () => {},
	activeSlotHandler: () => {},
	updatePageDataHandler: () => {},
	updateContentHandler: () => {},
	toggleGeneratePdfOpen: () => {},
	movePageHandler: () => {},
});

export default EditorContext
